// Copies a string to the clipboard. Must be called from within an event handler such as click.
function copyToClipboard(text) {

    //If you're not supporting IE you can use Write Text and reduce the bloat: navigator.clipboard.writeText();
    //Docs: https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText

    if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text);
    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            //console.warn("Copy to clipboard failed :(.", ex);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}

// jQuery Function
(function($) {

/* Look for class in dom - i've used a class on ahref - so there's a link fall back */
var copyUrlExists = document.querySelector('.copy-url');

/* Check */
if(copyUrlExists){

/* On Click */
document.querySelector(".copy-url").onclick = function(event) {

    /* Stop it from doing it's normal thing */
    event.preventDefault();
    /* Get URL */
    let url = '';
    let target = event.target || event.srcElement;
    /* Check Again */
    while (target) {
        if (target instanceof HTMLAnchorElement) {
          url = target.getAttribute('href');
          break;
        }
        target = target.parentNode;
    }
    /* Send to Clipboard */
    let result = copyToClipboard(url);
    let message = '';
    /* Set message */
    if(result){
        message = "URL copied";
    }else{
        message = "Try again";
    }

    /* Message - Add to the dom */

    /* Check to make sure element doesn't already exist - this is basic but helps to reduce click attacks */
    var toolTipExists = document.querySelector('.share_tooltip');

    if(toolTipExists){
        //Do Nothing or count events to add further click attack protection.
    }else{
        //Create the Tooltip
        const toolTip = document.createElement('span');
        toolTip.style.visibility = 'block';
        toolTip.className = 'share_tooltip';
        target.appendChild(toolTip);
        toolTip.innerHTML = message;
        /* Fade In & Out */
        $(toolTip).delay(1000).animate({opacity: 0}, 500, function(){
            toolTip.remove();
        });
    };
};
}else{
    /* Do Nothing */
}
// This Theme uses jQuery so is hooked into that.
})(jQuery);
